import React, { useState } from 'react';
import CancelModel from '../../../components/shared/ModelBox/CancelModel';
import Modal from 'react-bootstrap/Modal';
import { ModalBody, Table } from 'react-bootstrap';
import { setLocalStorage } from '../../../utils/storageUtil';

const SchemeCard = (props) => {
  // const { schemeName, interestPA, schemeCode, className, setFieldValue } = props;
  const { className, setFieldValue, scheme } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 ">
      <div className="card text-white card-has-bg click-col">
        <div className="card-img-overlay d-flex flex-column">
          <div className="card-body">
            <h4 className="card-meta mb-2">{scheme?.name}</h4>
            <>
              <h4 className="card-title mt-2 mb-4 ">
                <p className="text-white percentage">{scheme?.interestRate}% p.a</p>
              </h4>
              <ul className="card-description">
                <li>Minimum balance {`${scheme?.mainCurrency} ${scheme?.minBalance}/-`}</li>
              </ul>
            </>
          </div>
          <div className="card-footer">
            <div className="float-right">
              <button
                type="submit"
                onClick={() => {
                  setFieldValue('schemeName', scheme?.name);
                  setFieldValue('accountScheme', scheme?.accountScheme);
                  setLocalStorage('maxAge', scheme?.maxAge);
                  setLocalStorage('minAge', scheme?.minAge);
                  setLocalStorage('schemeName', scheme?.name);
                }}
                className={className + ' apply-now-btn '}
              >
                Apply now &#8702;
              </button>
            </div>

            <button
              type="button"
              className={className + ' apply-now-btn  '}
              style={{ width: '100px' }}
              onClick={() => handleShow(true)}
            >
              Details &#8702;
            </button>

            <Modal size="md" show={show} onHide={handleClose} centered>
              <Modal.Header closeButton closeVariant="red">
                <h4>Details</h4>
              </Modal.Header>
              {scheme?.accountScheme === 'GBNRN-0736' ? (
                <Modal.Body>
                  <Table bordered>
                    <thead>
                      <tr style={{ textAlign: 'center', color: '#1035AC' }}>
                        <th>Global NRN FCYs Saving Deposit</th>
                        <th>Min. Balance</th>
                        <th>Rates per Annum</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>US Dollar(USD)</td>
                        <td>USD 1000/-</td>
                        <td>5.75%</td>
                      </tr>
                      <tr>
                        <td>Euro(EUR)</td>
                        <td rowSpan={6} style={{ verticalAlign: 'middle' }}>
                          Equivalent to <br />
                          USD 1000/-
                        </td>
                        <td>4.00%</td>
                      </tr>
                      <tr>
                        <td>Great Britian Pound(GBP)</td>
                        <td>4.50%</td>
                      </tr>
                      <tr>
                        <td>Australian Dollar(AUD)</td>
                        <td>4.50%</td>
                      </tr>
                      <tr>
                        <td>Canadian Dollar(CAD)</td>
                        <td>4.00%</td>
                      </tr>
                      <tr>
                        <td>Japanese Yen(JPY)</td>
                        <td>2.00%</td>
                      </tr>
                      <tr>
                        <td>Chinese Yuan(CNY)</td>
                        <td>2.00%</td>
                      </tr>
                    </tbody>
                  </Table>
                </Modal.Body>
              ) : (
                <Modal.Body>
                  <Table bordered>
                    <thead>
                      <tr style={{ textAlign: 'center', color: '#1035AC' }}>
                        <th style={{ width: '50%' }}>Scheme</th>
                        <th style={{ width: '50%' }}>{scheme?.name}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Interest Rate</td>
                        <td>{scheme?.interestRate}</td>
                      </tr>
                      <tr>
                        <td>Currencies</td>
                        <td>{scheme?.currencies?.join(', ')}</td>
                      </tr>
                      <tr>
                        <td>Minimum Balance</td>
                        <td>
                          {scheme?.mainCurrency} {scheme?.minBalance}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: 'middle' }}>Description</td>
                        <td>{scheme?.description}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Modal.Body>
              )}

              <Modal.Footer>
                <button
                  type="button"
                  className={className + ' apply-now-btn '}
                  onClick={handleClose}
                  GBNRN-0736
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchemeCard;
